import React, { useState, useContext, useRef, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from "react-i18next";
import { TextField, InputAdornment } from "@mui/material";
import "../../styles/components/Editor.scss";
import "../../styles/components/EditorModal.scss";
import DropDownWithSearchTemplate from "../../components/DropDownWithSearchTemplate";
import DropDownWithLabelSizeTemplate from "../../components/DropdownWithLabelSizeTemplate.js";
import ErrComponentToRender from "../../Uitls/apiErrorHandling";
import infoIcon from "../../images/infoIcon.svg";
import { nameValidation } from "../../Uitls/Util.js";
import DropDownWithLabelTemplate from "../DropDownWithLabelTemplate.js";
import {
  getNewBrandsAndcampaigns,
  cloneBanner,
  getMarketList,
} from "../../services/apis";
import { toast } from "react-toastify";
//Denovo related imports
//MArket Data returnlated imports and varaihle declaration
import ValueContext from "../../ContextAPi/appContext";
import Button from "@mui/material/Button";
import { templateSizes } from "../../Uitls/RightPanelToolBarItems";
import TextFieldInputTemp from "../../components/CommonComponents/TextFieldInputTemp";

export default function BasedOnModal(props) {
  const history = useHistory();
  const { t } = useTranslation();
  const { recentlyViewedData } = props;
  const appData = useContext(ValueContext);
  const [brandsAndCampaigns, setBrandsAndCampaigns] = useState([]);
  const [marketDataSource, setMarketDataSource] = useState([]);
  const [selectedMarket, setSelectedMarket] = useState(undefined);
  const [helperText, setHelperText] = useState("");
  const [errorMsg, setErrorMsg] = useState(false);
  const templateSizeOptions = ["Pre-defined", "Custom"];
  const [attributes, setAttributes] = useState({});
  const [genericInfo, setGenericInfo] = useState({
    brand: "",
    campaign: "",
    market: "",
    bannerNameInput: "",
    promomatTempDocId: "ES-BVY-0064",
    bannerType: "",
    bannerSizeType: "",
  });
  const handleFormReset = () => {
    setGenericInfo({
      brand: "",
      campaign: "",
      market: "",
      bannerNameInput: "",
    });
    setSelectedMarket("");
  };

  React.useEffect(() => {
    setGenericInfo({ ...genericInfo, campaign: "" });
  }, [genericInfo.brand]);

  React.useEffect(() => {}, []);

  React.useEffect(() => {
    fetchBrandsAndCampaigns();
    fetchMarketData();
    getCampaignListToPopulate(
      appData?.genericInfo?.brand || recentlyViewedData?.brand
    );
  }, []);

  useEffect(() => {
    setGenericInfo({
      ...genericInfo,
      campaign: appData?.genericInfo?.campaign,
      brand: appData.genericInfo.brand,
      market: appData.genericInfo.market,
      bannerType: appData?.genericInfo?.isAnimated ? "Animated" : "Static",
      bannerSizeType: appData?.attributes?.customTemp
        ? "Custom"
        : "Pre-defined",
      bannerSize: getTemplateSize(
        appData?.genericInfo?.height,
        appData?.genericInfo?.width
      ),
      Width: appData?.genericInfo?.width,
      Height: appData?.genericInfo?.height,
    });
    setAttributes(appData?.attributes);
  }, []);
  //Fetch Brands and campaigns
  const fetchBrandsAndCampaigns = () => {
    getNewBrandsAndcampaigns((response, err, errCode) => {
      if (err) {
        const errCoponent = ErrComponentToRender(errCode);
        toast.error(errCoponent);
      } else {
        //parse and save
        const data = response.data;
        if (data && data.length > 0) {
          let sortedData;
          sortedData = data.slice().sort((a, b) => {
            const brandNameA = a.brandName.trim().toUpperCase();
            const brandNameB = b.brandName.trim().toUpperCase();
            return brandNameA.localeCompare(brandNameB, "en", {
              sensitivity: "base",
            });
          });
          sortedData = [...sortedData].map((data) => {
            let object = data;
            object["displayName"] = `${object.brandName}`;
            return object;
          });
          setBrandsAndCampaigns(sortedData);
        }
      }
    });
  };

  //Returns Campaign list to populate in Drop down
  const getCampaignListToPopulate = (Brand) => {
    if (Brand && brandsAndCampaigns.length > 0) {
      const campaigns = brandsAndCampaigns.filter((object) => {
        return object.brandName === Brand;
      })[0]?.campaigns;
      if (campaigns && campaigns.length > 0) {
        const desiredList = campaigns.map((campaign) => {
          return campaign["campaignName"];
        });
        if (desiredList && desiredList.length > 0) {
          return desiredList;
        }
      }
    }
    return [];
  };

  function validateForm() {
    return (
      genericInfo.bannerNameInput &&
      genericInfo.bannerNameInput.trim() !== "" &&
      genericInfo.brand?.length > 0 &&
      genericInfo.market?.length > 0 &&
      genericInfo.bannerType?.length > 0 &&
      (genericInfo.bannerSize?.length > 0 ||
        (genericInfo.Width > 0 && genericInfo.Height > 0))
    );
  }
  const handleChangeInfoDataBlur = (e) => {
    if (e.target.value.length < 3 && e.target.value.length !== 0) {
      toast.error(
        <div className="notificationText">
          {t("bannerManager.bnrNameMinErr")}
        </div>
      );
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    setGenericInfo({ ...genericInfo, [name]: value });
    if (name === "templateNameInput") {
      if (e.target.value.length > 255) {
        toast.error(
          <div className="notificationText">
            {t("bannerManager.tempNameErr")}
          </div>
        );
      }
    }

    if (brandsAndCampaigns) {
      brandsAndCampaigns.forEach((brand) => {
        if (brand.brandName === value) {
          appData.setBrandId(brand.brandId);
        }
        brand.campaigns.forEach((campaign) => {
          if (campaign.campaignName === value) {
            appData.setCampaignId(campaign.campaignId);
          }
        });
      });
    }
  };

  const handleChangeInfoData = (e) => {
    const { name, value } = e.target;
    setGenericInfo({ ...genericInfo, [name]: value });
    if (name === "bannerNameInput") {
      if (e.target.value.length > 500) {
        toast.error(
          <div className="notificationText">
            {t("bannerManager.bnrNameErr")}
          </div>
        );
      }
    }
    if (brandsAndCampaigns) {
      brandsAndCampaigns.forEach((brand) => {
        if (brand.brandName === value) {
          appData.setBrandId(brand.brandId);
        }
        brand.campaigns.forEach((campaign) => {
          if (campaign.campaignName === value) {
            appData.setCampaignId(campaign.campaignId);
          }
        });
      });
    }
    let obj = { ...appData?.genericInfo, [name]: value };
    appData.updateGenericInfo(obj);
    setErrorMsg(false);
    setHelperText("");
  };

  const fetchMarketData = () => {
    getMarketList((response, err, errCode) => {
      if (err) {
        const errCoponent = ErrComponentToRender(errCode);
        toast.error(errCoponent);
      } else {
        //parse and save

        const data = response.data;
        if (data) {
          let marketData = data;
          if (marketData && marketData.length > 0) {
            marketData = [...marketData].map((market) => {
              let object = {
                code: market.countryDamId,
                shortName: market.ShortName,
                name: market.marketName,
              };
              object["displayName"] = `${object.name}`;
              return object;
            });
            if (marketData && marketData.length > 0) {
              marketData = [...marketData].sort((marketOne, marketTwo) => {
                if (marketOne.name < marketTwo.name) {
                  return -1;
                }
                if (marketOne.name > marketTwo.name) {
                  return 1;
                }
                return 0;
              });
              setMarketDataSource(marketData);
            }
          }
        }
      }
    });
  };
  const handleMarketChange = (market) => {
    if (market) {
      setSelectedMarket(market);
      setGenericInfo({ ...genericInfo, market: market.name });
      appData.setMarketCode(market.code);
      appData.updateGenericInfo({
        ...appData?.genericInfo,
        market: market.name,
      });
    }
  };

  const getSelectedMarket = () => {
    if (!selectedMarket && appData && appData?.genericInfo?.market) {
      const countryName = appData?.genericInfo?.market;
      const countryCode = appData.marketCode;
      const displayName = `${countryName}`;
      return { name: countryName, code: countryCode, displayName: displayName };
    }
    return selectedMarket;
  };

  const categoriesErr = (value) => {
    toast.error(value, { position: toast.POSITION.TOP_RIGHT });
  };
  const cloneBannerData = () => {
    if (!nameValidation(genericInfo.bannerNameInput, "Banner")) return;

    const formData = new FormData();
    const match = genericInfo.bannerSize.match(/\d{2,4}x\d{2,4}/);
    var bannerSizeRes = match[0].split("x");
    formData.append(
      "width",
      parseInt(bannerSizeRes[0]) || parseInt(genericInfo.Width)
    );
    formData.append(
      "height",
      parseInt(bannerSizeRes[1]) || parseInt(genericInfo.Height)
    );
    formData.append("brandName", appData?.genericInfo?.brand || "");
    formData.append("name", appData?.genericInfo?.bannerNameInput);
    formData.append("campaign", appData?.genericInfo?.campaign);
    formData.append("brandId", appData?.brandId);
    formData.append("marketName", appData?.genericInfo?.market);
    formData.append("attributes", JSON.stringify(attributes));
    formData.append("marketCode", appData?.marketCode);

    cloneBanner(
      appData.assetInfo.assetId,
      formData,
      (response, err, errorCode, errorMessage) => {
        if (err) {
          const errComponent = ErrComponentToRender(errorCode);
          if (err.response.data?.errorCode === "ERR_CS_ASSETNAME_EXISTS") {
            toast.error(
              <div className="notificationText">
                {t("apiErrors.errBannerExist")}
              </div>
            );
          } else {
            toast.error(
              <div className="notificationText">{t("apiErrors.err500")}</div>
            );
          }
        } else {
          const obj = {
            brand: response.data.brandName,
            campaign: response.data.campaign,
            market: response.data.marketName,
            bannerNameInput: response.data.assetName,
          };
          appData.updateGenericInfo({ ...appData?.genericInfo, ...obj });
          setSelectedMarket(obj.market);
          appData.setAssetInfo({
            assetId: "",
            assetName: obj.bannerNameInput,
          });

          localStorage.removeItem("assetId");
          localStorage.setItem("assetId", response.data.id);
          history.push({
            pathname: `/banner-editor/${response?.data?.id}`,
          });
        }
      }
    );
  };
  const dropdownWidth = useRef(null);
  const handleChangeSizes = (e, id) => {
    let name = e.target.name;
    let value = e.target.value;
    setGenericInfo({
      ...genericInfo,
      bannerSizeType: value,
      bannerSize: "",
      Width: 0,
      Height: 0,
    });
  };
  function getTemplateSize(height, width) {
    for (let i = 0; i < templateSizes.length; i++) {
      const [name, size] = templateSizes[i].split(" ");
      const [templateWidth, templateHeight] = size.split("x").map(Number);

      if (templateWidth === width && templateHeight === height) {
        return templateSizes[i];
      }
    }

    return `${height}x${width}`;
  }

  useEffect(() => {
    setAttributes({
      ...attributes,
      customTemp: genericInfo?.bannerSizeType === "Custom" ? true : false,
    });
  }, [genericInfo.bannerSizeType]);
  return (
    <>
      <Dialog
        open={props.showBasedOn}
        onClose={() => props.setShowBasedOn(false)}
        className="newTemplateModal"
        aria-labelledby="form-dialog-title"
        overlaystyle={{ backgroundColor: "transparent" }}>
        <div className="row newBnrModal">
          <div
            className="baseOnModalHeading col-md-5 createbannerhead"
            style={{ fontFamily: "'Nunito Sans', sans-serif" }}
          >
            <p>{t("METADATA INFORMATION")}</p>
            <div className="details">
              <p className="sourcetag">Source</p>
              <p className="tagDescription">PromoMats</p>
              <hr className="custom-hr" />
            </div>
            <div className="details createdBtagy">
              <p className="sourcetag">Created by</p>
              <p className="tagDescription">-</p>
            </div>
            <div className="details">
              <p className="sourcetag">Created on</p>
              <p className="tagDescription">-</p>
            </div>
          </div>

          <div
            className="col-md-7 selectBrands customScrollBar"
            ref={dropdownWidth}
          >
            <TextField
              variant="standard"
              label={t("bannerManager.bannerName")}
              name="bannerNameInput"
              className="bannerNameTextfield templateNameTextfield templateNameTextfieldChanges bnrtxtField"
              fullWidth={true}
              value={genericInfo.bannerNameInput}
              onChange={handleChangeInfoData}
              onBlur={handleChangeInfoDataBlur}
              autoComplete="off"
              InputProps={{
                endAdornment: (
                  <InputAdornment
                    position="end"
                    style={{ color: "gray", fontSize: "12px" }}
                  >
                    {genericInfo.bannerNameInput?.length > 0 &&
                      `${genericInfo.bannerNameInput?.length}/500 chars`}
                  </InputAdornment>
                ),
              }}
              helperText={helperText}
              error={errorMsg}
            ></TextField>

            <TextField
              variant="standard"
              label={
                <>
                  {t("PromoMats Template Doc ID")}{" "}
                  <span style={{ color: "red" }}>*</span>
                </>
              }
              value={genericInfo?.promomatTempDocId}
              name="promomatTempDocid"
              className="bannerNameTextfield templateNameTextfield templateNameTextfieldChanges disablPromo iconinfo"
              fullWidth={true}
              autoComplete="off"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <img src={infoIcon} className="" />
                  </InputAdornment>
                ),
              }}
              disabled={true}
            ></TextField>
            <TextField
              variant="standard"
              value={appData?.genericInfo?.brand}
              name="brand"
              label={"Product"}
              className="bannerNameTextfield  templateNameTextfield ChangleCloneTextField"
              fullWidth={true}
              onChange={handleChangeInfoData}
              autoComplete="off"
              disabled="true"
            ></TextField>
            <DropDownWithSearchTemplate
              options={{
                value: getSelectedMarket(),
                name: "market",
                label: "Country",
                items: marketDataSource,
                handleChange: handleMarketChange,
              }}
              className="custonScrollBar"
            />
            <TextField
              id="standard-basic"
              variant="standard"
              label={t("Banner Type")}
              name="templateType"
              className="bannerNameTextfield templateNameTextfield ChangleCloneTextField"
              fullWidth={true}
              value={genericInfo?.bannerType}
              autoComplete="off"
              disabled="true"
            />
            <div
              className="newInputFieldTemp newInputFieldTempChanges"
              style={{ marginTop: "0px" }}
            >
              <DropDownWithLabelTemplate
                options={{
                  value: genericInfo?.bannerSizeType || "",
                  name: "templateSizeType",
                  label: (
                    <>
                      {t("Banner Size")} <span style={{ color: "red" }}>*</span>
                    </>
                  ),

                  items: templateSizeOptions,
                  handleChange: handleChangeSizes,
                  className: "testBannersize",
                }}
              />
            </div>
            {genericInfo?.bannerSizeType === "Pre-defined" && (
              <div
                className={
                  genericInfo.bannerSizeType === "Pre-defined"
                    ? "newSizeInputFieldTemp chooseSize newInputFieldTemp newSizeInputFieldTempWidth"
                    : "newSizeInputFieldTemp chooseSize2 newInputFieldTemp newSizeInputFieldTempWidth"
                }
              >
                <DropDownWithLabelSizeTemplate
                  options={{
                    value: genericInfo.bannerSize || "",
                    name: "bannerSize",
                    label: (
                      <>
                        {t("Choose Size")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </>
                    ),
                    items: templateSizes,
                    handleChange: handleChange,
                    className: "testBannersize",
                  }}
                />
              </div>
            )}
            {genericInfo?.bannerSizeType === "Custom" && (
              <TextFieldInputTemp
                assetType={"banner"}
                custom={true}
                setCustomSize={true}
                genericInfo={genericInfo}
                setGenericInfo={setGenericInfo}
                handleChange={handleChange}
                styleClass="hWTemplate2"
              />
            )}
          </div>
        </div>
        <DialogActions className="modalActions templateBtn">
          <Button
            onClick={() => {
              props.setShowBasedOn(false);
              handleFormReset();
            }}
            color="primary"
            className="cancelBtntemp"
          >
            {t("bannerManager.cancel")}
          </Button>
          <Button
            onClick={cloneBannerData}
            type="submit"
            className="temp-btn"
            disabled={!validateForm()}
            autoFocus
          >
            {t("bannerManager.cloneBanner")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
